var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewtag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.313,
    height: 25,
    viewBox: "0 0 64.313 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5869",
    "data-name": "Group 5869",
    transform: "translate(-425 -2356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M.149,0H55.913L48.954,25H.149L-8.4,12.921Z",
    transform: "translate(433.4 2356)",
    fill: "#ffa700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M-16.464-11.056l4.512,7.264h.032v-7.264h2.352V0H-12.08l-4.5-7.264h-.032V0H-18.96V-11.056Zm19.232,0v2.128H-3.056v2.272H2.288V-4.7H-3.056v2.576H2.9V0H-5.568V-11.056Zm5.152,0L9.632-3.6h.032l1.872-7.456h2.336L15.712-3.5h.032l1.776-7.552h2.464L17.008,0h-2.5L12.688-7.44h-.032L10.88,0H8.336L5.408-11.056Z",
    transform: "translate(457 2374)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewtag);
export default __webpack_public_path__ + "static/media/newtag.e7dc6bd4db0fdb21f08e263447435fc8.svg";
export { ForwardRef as ReactComponent };